import HeroSection from './components/HeroSection';
import CategoryGrid from './components/CategoryGrid';
import FeaturedArticles from './components/FeaturedArticles';
import FAQSection from './components/FAQSection';
import NewsletterSection from './components/NewsletterSection';

export default function Home() {
  return (
    <>
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            '@context': 'https://schema.org',
            '@type': 'WebSite',
            name: '福利导航',
            url: 'https://fulidaohang.com/',
            description: '一站式福利资源聚合平台，汇聚折扣优惠、会员权益、生活补贴、职场福利等海量信息。',
            potentialAction: {
              '@type': 'SearchAction',
              target: 'https://fulidaohang.com/search?q={search_term_string}',
              'query-input': 'required name=search_term_string',
            },
          }),
        }}
      />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            '@context': 'https://schema.org',
            '@type': 'Organization',
            name: '福利导航',
            url: 'https://fulidaohang.com/',
            description: '一站式福利资源聚合平台',
          }),
        }}
      />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            '@context': 'https://schema.org',
            '@type': 'WebPage',
            name: '福利导航 - 一站式福利资源聚合平台',
            description: '福利导航是您发现优质福利资源的最佳入口，汇聚各类折扣优惠、会员权益、生活补贴、职场福利等海量信息。',
            url: 'https://fulidaohang.com/',
          }),
        }}
      />

      <main>
        <HeroSection />
        <CategoryGrid />
        <FeaturedArticles />
        <FAQSection />
        <NewsletterSection />
      </main>
    </>
  );
}